import { ProductTemporalityCondition } from '@core/models/product.model';

export type DataTypeOption<C> = { key: string; value: C };
export type DataTypeOptions<C> = DataTypeOption<C>[];
export type DataType =
  | string
  | boolean
  | number
  | Currency
  | Day
  | Month
  | Gender
  | CivilStatus
  | City
  | University
  | EmploymentRelationship
  | Employment
  | MonthlyExpenditure
  | SavingOrInvestment
  | InvestorProfile
  | FuturePlan
  | Loan
  | ProductTemporalityCondition;
export type DataTypeAvailableOptions = DataTypeOptions<DataType>;
export type ConditionalOption<C> = DataTypeOption<C> & { inactive?: boolean };

export type Currency = string;

export function getCurrencyKey(currencyValue: string, currencyOptions: DataTypeOptions<string>) {
  const currencyOption = currencyOptions.find(c => c.value === currencyValue);
  if (currencyOption) {
    return currencyOption.key;
  }
  return 'EUR';
}

export type Day = number;
export const Days: DataTypeOptions<Day> = [
  { key: '1', value: 1 },
  { key: '2', value: 2 },
  { key: '3', value: 3 },
  { key: '4', value: 4 },
  { key: '5', value: 5 },
  { key: '6', value: 6 },
  { key: '7', value: 7 },
  { key: '8', value: 8 },
  { key: '9', value: 9 },
  { key: '10', value: 10 },
  { key: '11', value: 11 },
  { key: '12', value: 12 },
  { key: '13', value: 13 },
  { key: '14', value: 14 },
  { key: '15', value: 15 },
  { key: '16', value: 16 },
  { key: '17', value: 17 },
  { key: '18', value: 18 },
  { key: '19', value: 19 },
  { key: '20', value: 20 },
  { key: '21', value: 21 },
  { key: '22', value: 22 },
  { key: '23', value: 23 },
  { key: '24', value: 24 },
  { key: '25', value: 25 },
  { key: '26', value: 26 },
  { key: '27', value: 27 },
  { key: '28', value: 28 },
  { key: '29', value: 29 },
  { key: '30', value: 30 },
  { key: '31', value: 31 }
];

export type Month = number;
export const DefaultMonths: DataTypeOptions<Month> = [
  { key: 'Enero', value: 1 },
  { key: 'Febrero', value: 2 },
  { key: 'Marzo', value: 3 },
  { key: 'Abril', value: 4 },
  { key: 'Mayo', value: 5 },
  { key: 'Junio', value: 6 },
  { key: 'Julio', value: 7 },
  { key: 'Agosto', value: 8 },
  { key: 'Septiembre', value: 9 },
  { key: 'Octubre', value: 10 },
  { key: 'Noviembre', value: 11 },
  { key: 'Diciembre', value: 12 }
];

export type Year = number;

export type Gender = string;
export type IdentityDocumentOptions = string;
export type CivilStatus = string;
export type City = string;
export type University = string;
export type EmploymentRelationship = string;
export type Employment = string;
export type MonthlyExpenditure = string;
export type SavingOrInvestment = string;
export type InvestorProfile = string;
export type FuturePlan = string;
export type Loan = string;
export type Insurance = 'DEATH' | 'EDUCATION' | 'SAVING' | 'RETIREMENT' | 'DECUMULATION';
export type Frequency = 'Anual' | 'Mensual' | 'Trimestral' | 'Semestral';
export const DefaultFrequencies: DataTypeOptions<Frequency> = [
  { key: 'Anual', value: 'Anual' },
  { key: 'Mensual', value: 'Mensual' },
  { key: 'Trimestral', value: 'Trimestral' },
  { key: 'Semestral', value: 'Semestral' }
];
export const DefaultFrequency: Frequency = 'Anual';

export const MinContributionYears = 1;
export const MaxContributionYears = 50;
